module.exports = __webpack_public_path__ + "static/media/LK_Configurator.bb255b24.svg";